/**
 * Site-wide details editable in Admin → Site settings. These defaults render
 * until (or unless) the admin saves its own values; see src/data/remote.ts.
 */
export type SiteInfo = {
  supportEmail: string;
  addressLine: string;
  /** Optional line in the top bar; empty keeps the default brand line. */
  announcement: string;
  social: { facebook: string | null; instagram: string | null; youtube: string | null; linkedin: string | null };
};

export const SITE: SiteInfo = {
  supportEmail: 'support@vertexpaint.com',
  addressLine: 'Khanna, Ludhiana, Punjab, India',
  announcement: '',
  social: { facebook: null, instagram: null, youtube: null, linkedin: null },
};

/** Only allow https links from the admin into href attributes. */
export const safeHttps = (u: string | null | undefined) => (u && /^https:\/\//i.test(u) ? u : null);
